import SyncRoomHead from './Head';
import SyncRoomList from './List';

import './style';

const SyncRoom = {
    Head: SyncRoomHead,
    List: SyncRoomList,
}

export default SyncRoom;
